// Imports

import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { Autoplay } from 'swiper/modules';

const isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;


window.Alpine = Alpine;
Alpine.start();

////////////////////////////// Init Functions /////////////////////////////////////

// Functions 
function l(m) {
  console.log(m);
}

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
});


function init() {
  l('👍');
  swiper();
}



function swiper() {
  if (document.querySelector(".swiper")) {
    l("load swiper");
    const swiper = new Swiper('.swiper', {
      modules: [Pagination, Autoplay],
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
}